import { useState } from 'react'
import { Link } from 'react-router-dom'
import { MailCheck } from 'lucide-react'
import api from '../api/client'
import AuthShell, { inputCls, btnCls, btnStyle } from './AuthShell'

export default function EsqueciSenha() {
  const [ident, setIdent] = useState('')
  const [enviado, setEnviado] = useState(false)
  const [loading, setLoading] = useState(false)

  async function submit(e) {
    e.preventDefault()
    setLoading(true)
    try {
      await api.post('/auth/esqueci-senha', { identificador: ident.trim() })
      setEnviado(true)
    } catch {
      setEnviado(true)   // resposta genérica (não vaza existência)
    } finally { setLoading(false) }
  }

  if (enviado) {
    return (
      <AuthShell titulo="Verifique suas mensagens"
        rodape={<Link to="/login" className="font-semibold text-accent-600 hover:underline">Voltar ao login</Link>}>
        <div className="text-center">
          <div className="mx-auto w-14 h-14 rounded-2xl bg-emerald-50 border border-emerald-200 flex items-center justify-center mb-4">
            <MailCheck className="text-emerald-500" size={26} />
          </div>
          <p className="text-sm text-gray-600">
            Se o cadastro existir, enviamos as instruções de redefinição por <b>e-mail</b> e <b>WhatsApp</b>.
            O link é válido por 2 horas.
          </p>
        </div>
      </AuthShell>
    )
  }

  return (
    <AuthShell titulo="Esqueci minha senha" subtitulo="Informe seu CPF ou e-mail cadastrado"
      rodape={<Link to="/login" className="text-gray-500 hover:underline">Voltar ao login</Link>}>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm font-semibold text-graphite mb-1">CPF ou E-mail</label>
          <input value={ident} onChange={(e) => setIdent(e.target.value)} required placeholder="Seu CPF ou e-mail" className={inputCls} />
        </div>
        <button disabled={loading || !ident.trim()} className={btnCls} style={btnStyle}>
          {loading ? 'Enviando...' : 'Enviar link de redefinição'}
        </button>
      </form>
    </AuthShell>
  )
}
